import PageHeader from "../components/PageHeader";
import WorkflowCards from "../components/WorkflowCards";

export default function FormsPage({ onStart }) {
  return (
    <>
      <PageHeader eyebrow="Intake" title="Forms" description="Start the correct workflow without hunting for links." />
      <WorkflowCards onStart={onStart} />
    </>
  );
}
